import {
  Box,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Button,
  ThemeProvider,
} from '@mui/material'
import React from "react"
import Header from '../../components/Header'
import { useState, useEffect } from 'react'
import { useTheme } from '@mui/material'
import { useParams } from 'react-router-dom'

import * as Constants from '../../constants'

const Device = () => {
  let theme = useTheme()

  const [error, setError] = useState({ error: false, message: '' })
  const [success, setSuccess] = useState({ success: false, message: '' })
  const [owners, setOwners] = useState([])
  const [selectedOwners, setSelectedOwners] = useState([])

  const handleSelect = (event) => {
    if (!selectedOwners.includes(event.target.value)) {
      console.log('does not include')
      setSelectedOwners([...selectedOwners, event.target.value])
      console.log('Setting it to: ' + [...selectedOwners, event.target.value])
    } else {
      console.log('includes')
      setSelectedOwners(
        selectedOwners.filter((owner) => owner !== event.target.value)
      )
    }
    console.log(selectedOwners)
  }

  const usernames = useParams().ids
  console.log(usernames)

  const handleSubmit = () => {
    fetch(Constants.HOST + '/setOwner', {
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
      body: JSON.stringify({
        token: JSON.parse(localStorage.getItem('user_data')).token,
        usernames: usernames.split(',').filter((username) => username !== ''),
        owner_ids: selectedOwners,
      }),
    })
      .then((response) => {
        if (response.status !== 400 && response.status !== 200) {
          setError({
            error: true,
            message: 'Erro de comunicação com o servidor',
          })
          setSuccess({ success: false, message: '' })
        } else {
          response.json().then((data) => {
            console.log(data);
            if (!data.success) {
              setError({ error: true, message: data.message})
              setSuccess({ success: false, message: '' })
            } else {
              setError({ error: false, message: '' })
              setSuccess({ success: true, message: data.message})
            }
          })
        }
      })
      .catch((error) => {
        setError({ error: true, message: 'Erro de comunicação com o servidor' })
        setSuccess({ success: false, message: '' })
      })
  }

  useEffect(() => {
    // Fetch owners
    fetch(Constants.HOST + '/owners', {
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
      body: JSON.stringify({
        token: JSON.parse(localStorage.getItem('user_data')).token,
      }),
    })
      .then((response) => {
        if (response.status !== 400 && response.status !== 200) {
          setError({
            error: true,
            message: 'Erro de comunicação com o servidor',
          })
          setSuccess({ success: false, message: '' })
        } else {
          response.json().then((data) => {
            data = data.data
            if (data.owners === undefined || data.owners.length === 0) {
              setError({
                error: true,
                message: 'Erro de comunicação com o servidor',
              })
              setSuccess({ success: false, message: '' })
            } else {
              setError({ error: false, message: '' })
              setSuccess({ success: false, message: '' })
              setOwners(data.owners)
            }
          })
        }
      })
      .catch(() => {
        setError({ error: true, message: 'Erro de comunicação com o servidor' })
        setSuccess({ success: false, message: '' })
      })
  }, [])

  return (
    <Box m="20px">
      <Header
        title="Atribuindo proprietários que o usuário administra"
        subtitle={
          'Editando usuário(s): ' +
          (usernames.split(',').length === 1
            ? usernames.split(',')[0]
            : usernames) +
          ' Proprietários atuais serão removidos, apenas os selecionados nessa tela serão atribuídos. Cada usuário pode gerenciar mais de um proprietário!'
        }
      />
      {error.error && (
        <div style={{ color: 'red', margin: '10px 0' }}>{error.message}</div>
      )}
      {success.success && (
        <div style={{ color: 'green', margin: '10px 0' }}>
          {success.message}
        </div>
      )}

      <ThemeProvider theme={theme}>
        <Box sx={{ flexGrow: 1, display: 'flex' }}>
          <FormGroup>
            {owners.map((owner) => (
              <FormControlLabel
                key={owner.id}
                control={
                  <Checkbox
                    onChange={handleSelect}
                    onClick={() =>
                      this
                        ? this.setState({ isTrue: !this.state.isTrue })
                        : null
                    }
                    value={owner.id}
                    color="primary"
                    sx={{
                      '& .MuiSvgIcon-root': {
                        fontSize: 28,
                      },
                      '&.Mui-checked': {
                        color: 'green',
                      },
                      '.MuiCheckbox-root': {
                        display: 'inline-flex',
                      },
                    }}
                  />
                }
                label={owner.name}
              />
            ))}
            <Button
              variant="outlined"
              sx={{ marginLeft: '10px', bgcolor: 'green' }}
              onClick={() => handleSubmit(selectedOwners)}
            >
              Executar
            </Button>
          </FormGroup>
        </Box>
      </ThemeProvider>
    </Box>
  )
}

export default Device
